export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#D5C8FB\"/><path d=\"M11.8 10.117l8.832-3.279 1.23 3.28m-10.061 0H8.858c-.82 0-1.49.67-1.49 1.49v9.725c0 .82.67 1.49 1.49 1.49h14.196c.82 0 1.49-.67 1.49-1.49v-2.46m-12.743-8.756h11.253c.82 0 1.49.67 1.49 1.49V13.5m1.227 5.374h-6.819c-.894 0-1.64-.746-1.64-1.64V15.67c0-.894.746-1.64 1.64-1.64h6.819c.26 0 .484.224.484.485v3.875c.037.261-.186.485-.484.485z\" stroke=\"#1D1D1B\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M20.676 17.151a.676.676 0 100-1.351.676.676 0 000 1.351z\" fill=\"#1D1D1B\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};